import apiClient from './apiClient';

// Get OEM Partners
export const getOemPartnersApi = async (params) => {
  const response = await apiClient.get('/partners/almata-partners/oem-partners/list', { params });
  return response.data;
};

// Add OEM Partner
export const addOemPartnerApi = async (partnerData) => {
  if (!partnerData) {
    throw new Error('Partner data is required');
  }
  
  const formData = new FormData();
  
  // Append all fields to FormData
  Object.keys(partnerData).forEach(key => {
    if (key === 'logo' && partnerData[key]) {
      formData.append(key, partnerData[key]);
    } else if (key === 'stripeProductId' && Array.isArray(partnerData[key])) {
      partnerData[key].forEach(id => formData.append('stripeProductId[]', id));
    } else if (key === 'planDetails' && Array.isArray(partnerData[key])) {
      formData.append(key, JSON.stringify(partnerData[key]));
    } else if (key !== 'refreshParams' && partnerData[key] !== null && partnerData[key] !== undefined) {
      formData.append(key, partnerData[key]);
    }
  });

  const response = await apiClient.post('/partners/oem-partners', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Edit OEM Partner
export const editOemPartnerApi = async (partnerData) => {
  if (!partnerData) {
    throw new Error('Partner data is required');
  }
  
  const { id, ...data } = partnerData;
  const formData = new FormData();
  
  // Append all fields to FormData
  Object.keys(data).forEach(key => {
    if (key === 'logo' && data[key]) {
      formData.append(key, data[key]);
    } else if (key === 'stripeProductId' && Array.isArray(data[key])) {
      data[key].forEach(id => formData.append('stripeProductId[]', id));
    } else if (key === 'planDetails' && Array.isArray(data[key])) {
      formData.append(key, JSON.stringify(data[key]));
    } else if (key !== 'refreshParams' && data[key] !== null && data[key] !== undefined) {
      // Skip object types except for specific fields
      if (typeof data[key] === 'object' && !Array.isArray(data[key]) && key !== 'logo') {
        return;
      }
      // Convert boolean to string for FormData
      const value = typeof data[key] === 'boolean' ? String(data[key]) : data[key];
      formData.append(key, value);
    }
  });

  const response = await apiClient.put(`/partners/oem-partners?id=${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Delete OEM Partner
export const deleteOemPartnerApi = async (id) => {
  const response = await apiClient.delete('/partners/oem-partners', { data: { _id: id } });
  return response.data;
};

// Change OEM Status
export const changeOemStatusApi = async (data) => {
  const response = await apiClient.patch('/partners/almata-partners/oem-partners/status', data);
  return response.data;
};

// Get Scan Types
export const getScanTypesApi = async () => {
  const response = await apiClient.get('/admin/scan-types');
  return response.data;
};

// Reset OEM Partner Password
export const resetOemPasswordApi = async (data) => {
  const response = await apiClient.post('/partners/almata-partners/oem-partners/reset-password', data);
  return response.data;
};

// Get Plans
export const getPlansApi = async (almataId) => {
  const response = await apiClient.get(`/partners/almata-partners/${almataId}/plans`);
  return response.data;
};

// Get OEM Partner Users
export const getOemPartnerUsersApi = async (params) => {
  const response = await apiClient.get('/partners/almata-partners/oem-partners/user-list', { params });
  return response.data;
};

// Get User Details
export const getUserDetailsApi = async (userId) => {
  const response = await apiClient.get(`/partners/almata-partners/oem-partners/user-details/${userId}`);
  return response.data;
};

// Get OEM Partner Names
export const getOemPartnerNamesApi = async (almataId) => {
  const response = await apiClient.get(`/partners/almata-partners/oem-partners/names/${almataId}`);
  return response.data;
};

